import { Component, Input } from "@angular/core"

@Component({
    selector: "app-collection-poster",
    templateUrl: "./collection-poster.component.html",
    styleUrls: ["./collection-poster.component.less"],
})
export class CollectionPosterComponent {
    @Input() searchImage = null
    // Deprecated image
    @Input() posterImage = null
    @Input() resourceCount = null
    @Input() link = null
    @Input() alt = null
    @Input() gtmPrefix: string = ""
    @Input() absoluteUrl: string = ""
    placeholderImg: string = null

    constructor() {
        this.placeholderImg = require("../../../assets/placeholder-image.svg").default
    }

    getCollectionsPosterClass() {
        return `gtm-${this.gtmPrefix}-collection-card`
    }
}
